// extracted by mini-css-extract-plugin
export default {"info":"VerifyEmailPage_info__RTatZ","errorText":"VerifyEmailPage_errorText__Q2Mv3"};